import React from "react";
import HumanBanner from "../humanresources/HumanBanner";
import HomeClientLogo from "../../home/HomeClientLogo";
import HumanPotential from "../humanresources/HumanPotential";
import HomeCounter from "../../home/HomeCounter"
import HumanDiscuss from "../humanresources/HumanDiscuss";
import HumanBenefits from "../humanresources/HumanBenefits";
import HumanGoals from "../humanresources/HumanGoals";
import HumanCompany from "../humanresources/HumanCompany";
import HumanSmart from "../humanresources/HumanSmart";

const bannerData = {
  head: "Driving Efficiency and Control Across Finance Operations",
  desc: "Accelerate your financial workflows with greater speed, accuracy, transparency. From invoice processing and expense management to audits and contract control, Dox and Box empowers finance and accounting teams with centralized data, automated workflows, seamless collaboration.",
  slug: "",
  btn: "Contact Us",
  img: "/assets/images/human-resources-banner-img2.webp"
}

const humanPotentialData = {
  head: "Unlock the Value of Digital Finance Transformation",
  boxes: [
    {
      title: "Common Challenges in Finance & Accounting",
      list: [
        {
          label: "Manual, Time-Consuming Processes",
          desc: "Data entry, duplicate handling, paper-based workflows slow down operations and increase the risk of errors."
        },
        {
          label: "Limited Visibility",
          desc: "Scattered documents and unclear process statuses delay approvals, reporting, decision-making."
        },
        {
          label: "Audit & Compliance Pressure",
          desc: "Maintaining accurate records and staying audit-ready can be complex and resource-intensive."
        },
        {
          label: "Rising Operational Costs",
          desc: " Inefficient processes and manual handling increase overhead and impact profitability."
        },
      ]
    },
    {
      title: "Work smarter with Dox and box",
      list: [
        {
          label: "Automated Workflows",
          desc: "Streamline routine processes, reduce errors, free up time for high-value financial activities."
        },
        {
          label: "Real-Time Data Access",
          desc: "Centralized document management ensures your team always has access to up-to-date financial information."
        },
        {
          label: "Simplified Compliance",
          desc: "Secure archiving, audit trails, structured documentation keep you prepared for audits and regulatory reviews."
        },
        {
          label: "Measurable Efficiency Gains",
          desc: "Reduce processing time, improve accuracy, achieve cost savings through digital transformation."
        },
      ]
    }
  ]
}

const countData = [
  {
    number: "24",
    suffix: "K+",
    desc: "<b>Businesses Served</b>: Trusted by organizations across diverse industries"
  },
  {
    number: "99",
    suffix: "%",
    desc: "<b>Retrieval Accuracy</b>: Ensure fast, precise, reliable access to documents"
  },
  {
    number: "14",
    suffix: "K+",
    desc: "<b>Documents Digitized</b>: Converted into structured, indexed, fully searchable digital formats"
  },
  {
    number: "40",
    suffix: "%",
    desc: "<b>Efficiency Gains</b>: Reduce manual effort, streamline workflows, & operational productivity"
  },
]

const discussData = {
  head: "Smarter finance workflows starts here",
  desc: "Give our specialists a call on",
  number: "+91 9580374374",
  btn: "Contact Us",
  slug: "/contact",
  newClass: "finance-discuss-area"
}

const smartData = {
  head: "Transform Your Finance & Accounting Processes",
  desc: "Automate key financial operations and give your team secure, centralized access to all documents, within a single, intelligent platform.",
  boxes: [
    {
      label: "INVOICE PROCESSING",
      innerHead: "Faster, error-free invoice management",
      innerDesc: "Automate invoice capture, validation, approvals to accelerate processing cycles, reduce errors, strengthen vendor relationships.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/finance-smart-image1.webp"
    },
    {
      label: "RECEIVABLES MANAGEMENT",
      innerHead: "Improved visibility and control",
      innerDesc: "Manage outgoing invoices and related documents in one place, enabling faster verification and quicker response to customer queries.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/finance-smart-image2.webp"
    },
    {
      label: "EXPENSE MANAGEMENT",
      innerHead: "Simplified reimbursements",
      innerDesc: "Digitize receipts and automate approval workflows to ensure accurate, transparent, timely expense processing.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/finance-smart-image3.webp"
    },
    {
      label: "Procure-to-Pay",
      innerHead: "End-to-end process accuracy",
      innerDesc: "Connect purchase orders, deliveries, invoices through automated workflows to prevent errors, eliminate duplicate payments, ensure financial accuracy.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/finance-smart-image4.webp"
    },
    {
      label: "Financial Reporting",
      innerHead: "Real-time insights for better decisions",
      innerDesc: "Streamline reporting processes with centralized data, enabling faster closings and accurate, up-to-date financial visibility.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/finance-smart-image5.webp"
    },
    {
      label: "Contract Management",
      innerHead: "Stay in control of commitments",
      innerDesc: "Manage contracts with centralized storage, quick search, automated alerts to avoid missed deadlines and ensure compliance.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/finance-smart-image6.webp"
    },
    {
      label: "SECURE ARCHIVING",
      innerHead: "Always audit-ready",
      innerDesc: "Store financial documents securely with tamper-proof archiving and complete audit trails, ensuring compliance and easy access during audits.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/finance-smart-image7.webp"
    },

  ],
}

const benifitData = {
  head: "Digital Transformation Benefits Across Your Finance Ecosystem",
  boxClass: "",
  slides: [
    {
      label: "Centralized Data",
      desc: "Bring all invoices, contracts, financial records into one secure system for complete visibility and control.",
      img: '/assets/images/finance-benifits-cards-icon-1.webp'
    },
    {
      label: "Process Automation",
      desc: "Eliminate manual tasks with automated workflows for invoicing, approvals, reporting.",
      img: '/assets/images/finance-benifits-cards-icon-2.webp'
    },
    {
      label: "Audit-Ready Compliance",
      desc: "Maintain accurate, audit-ready records with secure archiving, access controls, full traceability.",
      img: '/assets/images/finance-benifits-cards-icon-3.webp'
    },
    {
      label: "Real-Time Insights",
      desc: "Access up-to-date data and reports to make faster, more informed financial decisions.",
      img: '/assets/images/finance-benifits-cards-icon-2.webp'
    },
  ]
}

const goalData = {
  head: "Why Finance Teams Choose Dox and Box?",
  boxes: [
    {
      img: "/assets/images/human-goal-icon1.webp",
      title: "Intelligent Data Capture",
      desc: "Automatically extract and structure key financial data, reducing manual input and improving accuracy.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon2.webp",
      title: "Process Automation",
      desc: "Accelerate workflows, from invoice approvals to audit preparation, saving time and increasing productivity.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon3.webp",
      title: "Document Hub",
      desc: "Store and access financial records in a centralized, searchable, secure environment.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon4.webp",
      title: "Seamless Collaboration",
      desc: "Enable real-time coordination across teams, departments, multiple business locations worldwide.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon5.webp",
      title: "Actionable Insights",
      desc: "Leverage structured data to monitor performance and make informed financial decisions.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon6.webp",
      title: "Security & Compliance",
      desc: "Ensure data protection with role-based access and compliance-ready systems aligned with regulatory standards.",
      slug: "",
    },
  ]
}

export default function Finance() {
  return (
    <>
      <HumanBanner data={bannerData} />
      <HomeClientLogo />
      <HumanPotential data={humanPotentialData} />
      <HomeCounter countData={countData} />
      <HumanDiscuss data={discussData} />
      <HumanBenefits data={benifitData} />
      <HumanSmart smartData={smartData} />
      <HumanGoals data={goalData} />
      <HumanCompany />
    </>
  )
}